export const GET_DATA_LIST = 'GET_DATA_LIST';
export const getDataList = () => ({
  type: GET_DATA_LIST,
});

export const GET_GROUP_DEVICE_DATA = 'GET_GROUP_DEVICE_DATA';
export const getGroupDeviceData = groupId => ({
  type: GET_GROUP_DEVICE_DATA,
  payload: {
    groupId,
  },
});

export const GET_GROUP_DEVICE_DATA_ON_TAB_CHANGE = 'GET_GROUP_DEVICE_DATA_ON_TAB_CHANGE';
export const getGroupDeviceDataOnTabChange = groupId => ({
  type: GET_GROUP_DEVICE_DATA_ON_TAB_CHANGE,
  payload: {
    groupId,
  },
});

export const SET_NOTIFICATION_READ = 'SET_NOTIFICATION_READ';
export const setNotificationRead = id => ({
  type: SET_NOTIFICATION_READ,
  payload: {
    id,
  },
});

export const GET_HISTORY_DATA = 'GET_HISTORY_DATA';
export const getHistoryData = (from, to, did, dataField) => ({
  type: GET_HISTORY_DATA,
  payload: {
    from,
    to,
    did,
    dataField,
  },
});
